var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSinglePack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0426 4.66602H3.95732C3.60598 4.66602 3.31532 4.93802 3.29198 5.28802L2.76132 13.244C2.70998 14.0133 3.32065 14.666 4.09198 14.666H11.908C12.6793 14.666 13.29 14.0133 13.2386 13.244L12.708 5.28802C12.6846 4.93802 12.394 4.66602 12.0426 4.66602Z",
    stroke: "#3E444A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 6.00065V3.33398V3.33398V3.33398C10.0007 2.22932 9.10533 1.33398 8.00067 1.33398H8C6.89533 1.33398 6 2.22932 6 3.33398V3.33398V3.33398V6.00065",
    stroke: "#3E444A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSinglePack);
export default __webpack_public_path__ + "static/media/single-pack.a68b8f2be89b3cdac317eb30497f1b76.svg";
export { ForwardRef as ReactComponent };